<template>
    <div>
        <div class="folder_list">
            <div class="top_opt">
                <v-btn :dense="true" @click="addFolder">新建文件夹</v-btn>
                <v-btn :dense="true" @click="goFolder">文件夹管理</v-btn>
            </div>  
            <v-treeview
                v-model="tree"
                :open="initiallyOpen"
                :items="items"
                activatable
                item-key="name"
                open-on-click
            >
                <template v-slot:prepend="{ item, open }">
                    <!-- {{item}} -->
                <v-icon v-if="open">
                    {{item.autoUpdate?'mdi-history': 'mdi-folder-open'}}
                    <!-- {{ open ? 'mdi-folder-open' : item.autoUpdate?'mdi-history':'mdi-folder' }} -->
                </v-icon>
                <v-icon v-else>
                    {{item.autoUpdate?'mdi-history': 'mdi-folder'}}
                    <!-- {{ files[item.file] }} -->
                </v-icon>
                </template>
                <template v-slot:label="{item}">
                    <div class="folder_list_label">
                        <span :title="item.name" @click="getDetail(item)">{{item.name}}</span>
                        <div class="opt">
                            <v-icon @click="changeFolder(item)">mdi-pencil-box-outline</v-icon>
                            <v-icon @click="delFolderItem(item)">mdi-delete-outline</v-icon>
                        </div>
                    </div>
                </template>
            </v-treeview>                
        </div>
        <v-dialog
        v-model="addVisible"
        width="500">
            <v-card>
            <v-card-title class="lighten-2">{{visibleTit}}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
            <v-form>
                <v-container>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form.name"
                            label="名称"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入名称"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    >
                    <div class="h36">
                        <v-text-field
                            v-model="form.description"
                            label="描述"
                            required
                            outlined
                            :dense="true"
                            placeholder="请输入描述"
                        ></v-text-field>
                    </div>
                    </v-col>
                </v-row>
                </v-container>
            </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click="handleAddCancel">
                取消
            </v-btn>
            <v-btn
                color="primary"
                @click="handleAddOk"
                v-if="visibleTit =='新建文件夹'"
            >
                确定
            </v-btn>
            <v-btn
                color="primary"
                @click="handleEditOk"
                v-if="visibleTit =='修改文件夹'"
            >
                确定
            </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import Qs from 'qs'
export default {
    data() {
        return {
            id: '',
            child: false,
            tree: [],
            initiallyOpen: [],
            files: {
                html: 'mdi-language-html5',
                js: 'mdi-nodejs',
                json: 'mdi-code-json',
                md: 'mdi-language-markdown',
                pdf: 'mdi-file-pdf',
                png: 'mdi-file-image',
                txt: 'mdi-file-document-outline',
                xls: 'mdi-file-excel',
            },
            items: [],
            addVisible: false,
            form: {},
            visibleTit: '新建文件夹'
        }
    },
    created() {
        this.id = this.$route.query.spaceId
        if(this.id) {
            this.getList()
        }
    },
    methods: {
        ...mapActions('folder',['folderList','folderSet','delFolder','editFolder','newFolder']),
        getList() {
            let data = {
                params: {
                    workspaceId: this.id
                }
            }
            let _this = this
            this.folderSet({data: data,handle(res) {
                let list = res.folders
                list = list.filter((item)=>{
                    return item.level == 0
                })
                if(list&&list[0]) {
                    _this.$store.commit('setFolderId', list[0].id)
                }
                _this.items = list
            }})
        },
        changeFolder(val) {
            this.visibleTit = '修改文件夹'
            this.addVisible = true
            this.form = val
            // this.form.name = val.name
            // this.form.description = val.description
        },
        delFolderItem(val) {
            this.$msgbox.confirm('此操作将永久删除该文件夹, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    params: {
                        id: val.id
                    }
                }
                let _this = this
                this.delFolder({data: data,handle(res) {
                    if(res.success) {
                        _this.$message({
                            type: 'success',
                            message: res.message
                        })
                        _this.getList()
                    }else {
                        _this.$message({
                            type: 'info',
                            message: res.message
                        })
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        addFolder() {
            this.form = {}
            this.visibleTit = '新建文件夹'
            this.addVisible = true
        },
        handleAddOk() {
            this.form.workspaceId = this.id
            let data = {
                params: this.form
            }
            let _this = this
            this.newFolder({data: data,handle(res) {
                _this.addVisible = false
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    })
                    _this.getList()
                }else {
                    _this.$message({
                        type: 'info',
                        message: res.message
                    })
                }
            }})
        },
        handleEditOk() {
            let data = {
                params: {
                    folderId: this.form.id,
                    name: this.form.name,
                    description: this.form.description
                }
            }
            let _this = this
            this.editFolder({data: data,handle(res) {
                 _this.addVisible = false
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    })
                    _this.getList()
                }else {
                    _this.$message({
                        type: 'info',
                        message: res.message
                    })
                }
            }})
        },
        handleAddCancel() {
            this.addVisible = false
        },
        goFolder() {
            this.$router.push({
                path: '/workSpace/folder',
                query: {
                    spaceId: this.id
                }
            })
        },
        getDetail(val) {
            if(this.$route.path.indexOf('/workSpace/detail')>-1) {
                this.$router.replace('?spaceId='+ this.id +'&folderId=' + val.id)
            }else {
                this.$router.push({
                    path: '/workSpace/detail',
                    query: {
                        spaceId: this.id,
                        folderId: val.id
                    }
                })
            }
            this.$store.commit('setFolderId', val.id)
        }
    }
}
</script>